import * as Sentry from '@sentry/browser';

if (typeof window.app.sentry.dsn !== 'undefined' && window.app.sentry.dsn) {
  Sentry.init({
    dsn: window.app.sentry.dsn,
    ignoreErrors: [
      'top.GLOBALS',
      'document.getElementsByClassName.ToString',
    ],
    ignoreUrls: [
      /graph\.facebook\.com/i,
      /connect\.facebook\.net\/en_US\/all\.js/i,
      /extensions\//i,
      /^chrome:\/\//i,
    ],
  });
}
